import { combineReducers } from 'redux';

import rolesReducer from './features/roles/reducer';
import toastsReducer from './features/toasts/reducer';
import eligibleReducer from './features/Eligible/reducer';
import userReducer from './features/User/reducer';
import configReducer from './features/Config/reducer';

const rootReducer = combineReducers({
  roles: rolesReducer,
  toasts: toastsReducer,
  eligible: eligibleReducer,
  user: userReducer,
  config: configReducer,
});

export default rootReducer;
